// extracted by mini-css-extract-plugin
module.exports = {"message":"_2VlpzwBua63ePY7rNL3em8","thought":"_33JgA_GbehsbNGurhG3tpT","avatar":"_3X4qiCwVqY0BhsjSXQWcOo"};